import * as swcHelpers from '@swc/helpers';
import { useState, useCallback, useEffect } from 'react';
import { Orders, ResponseError } from '@grandvisionhq/api-client';
import { Hooks } from '@grandvisionhq/carts-v2';
import { useLink } from '@grandvisionhq/frk-routing';
import { useApiConfig, useDispatch } from '@grandvisionhq/state';
import { getOrderByTokenSucces, getOrderByTokenFailed } from '../../actions.js';
import { removeCartFromLocalStorage } from '../../utils/remove-cart-from-local-storage.js';
import { errorsMapping } from '../../mappers/errors-mapping.js';

const useGetOrderData = (orderData)=>{
    const [isLoading, setIsLoading] = useState(true);
    const [error1, setError] = useState();
    const [orderResponse1, setOrderResponse] = useState();
    const routes = useApiConfig();
    const dispatch = useDispatch();
    const { refetch  } = Hooks.useGetCart();
    const { onClick: redirectToHomePage  } = useLink({
        route: 'home'
    }, {
        replace: true
    }) || {};
    const handleGetOrderData = useCallback(swcHelpers.asyncToGenerator(function*() {
        if (!orderData) {
            console.error('No order data found');
            redirectToHomePage === null || redirectToHomePage === void 0 ? void 0 : redirectToHomePage();
            return;
        }
        try {
            const orderResponse = yield Orders.getOrderByToken(routes.ordersUrl, {
                orderData
            });
            if (orderResponse.id) {
                setIsLoading(false);
                setOrderResponse(orderResponse);
                dispatch(getOrderByTokenSucces({
                    order: orderResponse
                }));
                removeCartFromLocalStorage();
            } else {
                dispatch(getOrderByTokenFailed(orderResponse));
            }
        } catch (error) {
            console.error(error);
            if (error instanceof ResponseError && error.statusCode === 404) {
                setError(errorsMapping.ORDER_NOT_FOUND);
            } else {
                setError(errorsMapping.SOMETHING_WENT_WRONG);
            }
            dispatch(getOrderByTokenFailed(error));
        }
    }), [
        orderData,
        routes.ordersUrl,
        dispatch,
        redirectToHomePage
    ]);
    useEffect(()=>{
        handleGetOrderData();
        refetch();
    /**
     * getOrderData and refetch are supposed to only call on page load
     * adding handleGetOrderData & refetch as deps results in
     * infinite loop of handleGetOrderData call
     */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        orderResponse1,
        isLoading,
        error1
    ];
};

export { useGetOrderData };
//# sourceMappingURL=use-get-order-data.js.map
